module.exports = __webpack_public_path__ + "static/media/notice_assurance_en.98c1e6d4.pdf";